<template>

  <HomepageWideLayout footer="no" wide-header="yes">
    <b-container fluid id="product-grid" class="p-0">
      <div id="catalog-header" :class="{'d-none': !product, 'd-sm-none': true}">
            <a @click="onClickCrumbs">
              <i class="fas fa-chevron-left fa-xs" />
              <span style="padding-left: 17px">Business Cards</span>
              <span class="sep">/</span>
              <span v-if="product">{{product.category}}</span>
            </a>
      </div>
      <b-row id="catalog-page" :class="{'showing-bar': isMobile && product}">
        <!-- Choose Category - LEFT -->
        <b-col sm="4" md="3" lg="2" id="products" :class="{'d-none': product}" class="d-sm-block p-0">
          <ProductList :autoselect="!isMobile" :slug="slug" v-model="product" />
        </b-col>

        <!-- RIGHT -->

        <b-col sm="8" md="9" lg="10" :class="{'d-none': !product}" class="d-sm-block right-side p-0" ref="right">
          <ProductPanel :product="product" />
        </b-col>
      </b-row>
    </b-container>

  </HomepageWideLayout>
</template>

<style scoped lang="scss">
@import '~scss/colors';

// HEADER

#back-button {
  line-height: 50px;
  margin-left: 20px;
}

#catalog-header {
  color:$black-2;
  padding: 7px 7px 5px 10px;
  text-transform: uppercase;
  font-weight: normal;
  font-size: 13px;
  letter-spacing: 3px;
  line-height: 10px;
  height: auto;
  background-color: $frost-0;
  border-color: $frost-0;
  cursor: pointer;
}

.breadcrumb {
    padding: .75rem 1rem;
    margin-bottom: 1rem;
    list-style: none;
    background-color: $white;
    border-radius: .25rem;
}
.breadcrumb-item.active {
    color: $red;
    @media screen and (max-width: 575.98px) {
      display: none;
    }
}


// BODY

#catalog-page {
  max-width: 1300px;
  margin: 0 auto;
  height: calc(100vh - 60px);
  &.showing-bar {
    height: calc(100vh - 89px);
  }

  @media only screen and (min-device-width: 1299px) {
    #catalog-page , #catalog-header {
      border-right:solid 1px $gray-1;
    }
    }
  }

.right-side {
  height: auto;
}
#product-grid {
  background-color: $frost-1;
}
#products {
  height: 100%;
  overflow: scroll;
}
@media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {
  #product-grid {
    overflow: auto;
    margin: 0;
    padding: 0;
  }
}
</style>

<script>
import ProductPanel from "./businesscards/shared/ProductPanel";
import ProductList from "./businesscards/shared/ProductList";
export default {
  props: ["slug"],
  data() {
    return {
      isMobile: false,
      product: null
      // This was the first name. We no longer auto select it.
      //productData.categories[0].products[0].name
    };
  },
  created() {
    // We need to know if the user is mobile,
    // since we don't auto-select a product for mobile
    let mql = window.matchMedia("(max-width: 575.98px)");
    let fn = () => this.isMobile = mql.matches;
    fn();
    mql.addListener(fn);
  },
  methods: {
    onClickCrumbs() {
      // On mobile, go back to list of items
      if (this.isMobile) this.product = null;
    }
  },
  components: {
    ProductList,
    ProductPanel
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/BusinessCardsNew.vue